/**
 * A place for all PCOM specific stuff
 */
import api from '@pu/js/plugins/api.js';
import axiosInstance from '@pu/js/plugins/axios.js';

export default {
    install(Vue, options) {
        // API abstraction available on Vue instances
        Vue.prototype.$api = api;

        // Axios instance available on Vue instances
        Vue.prototype.$axios = axiosInstance;

        // Loading spinner
        Vue.directive('is-loading', {
            bind(el, binding) {
                el.classList.toggle('is-loading', binding.value);
            },
            update(el, binding) {
                el.classList.toggle('is-loading', binding.value);
            },
        });
    },
};
